import { createElement } from "react";
import * as PropTypes from "prop-types";
import {Icon, MCIcon} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarBrand,
    UncontrolledDropdown,
} from "reactstrap";
import IconText from "./IconText";
import {LinkContainer} from "react-router-bootstrap";
import {withTranslation, WithTranslation} from "react-i18next";
import "./BaseAppWrapper.scss";

class BaseAppWrapper extends Component<WithTranslation> {

    static propTypes = {
        appCode: PropTypes.string,
        logoUrl: PropTypes.string,
        nazevSpolecnost: PropTypes.string,
        homeLink: PropTypes.oneOfType([
            PropTypes.func,   // pokud je uvedeno, volá se tento callback při klinutí
            PropTypes.string, // přesouvá se na uvedenou url - url pro router, pro renderování je použita komponenta homeLinkComponent, implicitně LinkContainer
        ]),
        homeLinkComponent: PropTypes.oneOfType([  // komponenta pro renderování home linku (ne back), implicitně LinkContainer
            PropTypes.func,
            PropTypes.string
        ]),
        onHistoryGoBack: PropTypes.func.isRequired,   // funkce pro zpracování posunu back, předpis: (goBackBase, homeLink) => {}
        backButtonIcon: PropTypes.bool,   // má se místo loga aplikace zobrazit back button?
        onLogout: PropTypes.func,  // logout funkce
        userMenuAddons: PropTypes.array,  // pole dalších tlačítek do menu pod uživatelem, typicky pole DropdownItem
        authStatus: PropTypes.object,   // informace o přihlášeném uživateli, předpis: {auth: bool, fullname: string, login: string}, pokud je null nebo je auth false, není přihlášen
    };

    static defaultProps = {
        homeLink: `${serverContextPath}`,
        homeLinkComponent: LinkContainer,
        collapseAddons: [],
        userMenuAddons: [],
        goBack: false,
    };

    historyGoBack = (e) => {
        const {onHistoryGoBack, goBackBase, homeLink} = this.props;

        e.stopPropagation();
        e.preventDefault();

        onHistoryGoBack(goBackBase, homeLink);
    };

    render() {
        const {homeLinkComponent, logoUrl, nazevSpolecnost, onLogout, userMenuAddons, authStatus, children, homeLink, goBack, backButtonIcon, appCode, t} = this.props;

        let userTexts = [];
        if (authStatus && authStatus.auth) {
            userTexts.push(authStatus.fullname || authStatus.login);
        }
        if (nazevSpolecnost) {
            userTexts.push(nazevSpolecnost);
        }

        const userMenu = <UncontrolledDropdown nav className="h-100">
            <DropdownToggle nav className="icon-text">
                <IconText icon={<Icon icon='user'/>} text={userTexts} />
            </DropdownToggle>
            <DropdownMenu right>
                {userMenuAddons}
                <DropdownItem onClick={onLogout}>{t('logout')}</DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>;

        const helpMenu = <UncontrolledDropdown nav className="h-100">
            <DropdownToggle nav className="icon-text">
                <IconText icon={<Icon icon='question-circle'/>}/>
            </DropdownToggle>
            <DropdownMenu right>
                <DropdownItem href={`${serverContextPath}/napoveda`} target="blank">{t('help')}</DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>;

        // Brand logo - ikona, název a případně popis
        let icon;
        if (backButtonIcon) {
            icon = <Icon fixedWidth className="header-app-icon" icon="chevron-left"/>;
        } else {
            icon = <MCIcon fixedWidth className="header-app-icon" icon={"cgo"} />;
        }

        const brandLogo = <div key="logo" className={"header-logo"}>
            {icon}
        </div>;

        // Celý brand včetně klikání
        let brand;
        if (goBack && this.props.history.length > 0) {   // máme aplikační historii a chceme jít zpět - jako v prohlížeči
            brand = <NavbarBrand href="" className="app-header-left" onClick={this.historyGoBack}>{brandLogo}</NavbarBrand>
        } else {
            if (typeof homeLink === "function") {
                brand = <NavbarBrand className="app-header-left" href="#" onClick={homeLink}>{brandLogo}</NavbarBrand>
            } else if (homeLink) {
                brand = createElement(homeLinkComponent, { to: homeLink, key: "brand" }, <NavbarBrand className="app-header-left" key="header">{brandLogo}</NavbarBrand>);
            } else {
                brand = <NavbarBrand className="app-header-left">{brandLogo}</NavbarBrand>;
            }
        }

        return (
            <div key="base-app-wrapper" className="app-wrapper">
                <div key="navbar" className="app-wrapper-navbar">
                    <Navbar key="navbar" className={"app-header navbar-light"} toggleable="sm">
                        <div key="container" className={"app-container"}>
                            {brand}
                            {<div className={"brand-logo"}>
                                <a href="#" onClick={() => this.props.history.push('/')}><img src={logoUrl} alt="CGO"/></a>
                            </div>}
                            {authStatus.auth && <Nav key="user-menu" className="app-menu" navbar>
                                {userMenu}
                            </Nav>}
                            <Nav key="help-menu" className="app-menu" navbar>
                                {helpMenu}
                            </Nav>
                        </div>
                    </Navbar>
                </div>
                <div key="content" className="app-wrapper-content">
                    {children}
                </div>
            </div>
        )
    }
}

export default withTranslation()(BaseAppWrapper);
